import React, { FC } from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  List,
  ListItem,
  ListItemPrefix,
  Typography,
} from "@material-tailwind/react";
import { motion } from "framer-motion";

interface SubItem {
  to: string;
  icon: React.ReactNode;
  label: string;
}

interface CustomAccordionProps {
  open: boolean;
  handleOpen: () => void;
  title: string;
  icon: React.ReactNode;
  subItems: SubItem[];
  customIcon?: React.ReactNode;
  activeSubItem: string | null;
  handleSubItemClick: (path: string) => void;
}

const CustomAccordion: FC<CustomAccordionProps> = ({
  open,
  handleOpen,
  title,
  icon,
  subItems,
  customIcon,
  activeSubItem,
  handleSubItemClick,
}) => {
  return (
    <Accordion open={open} icon={customIcon}>
      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="border-b-0">
        <AccordionHeader
          onClick={handleOpen}
          className="p-3 transition-colors border-b-0 hover:bg-blue-50 dark:hover:bg-blue-900"
        >
          <ListItemPrefix>{icon}</ListItemPrefix>
          <Typography color="blue-gray" className="mr-auto font-normal dark:text-white">
            {title}
          </Typography>
        </AccordionHeader>
      </motion.div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.3 }}
        className="overflow-hidden"
      >
        <AccordionBody className="py-1">
          <List className="p-0">
            {subItems.map((item, index) => (
              <motion.div key={index} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link to={item.to} onClick={() => handleSubItemClick(item.to)}>
                  <ListItem
                    className={`${
                      activeSubItem === item.to ? "font-bold bg-blue-50 dark:bg-blue-900" : ""
                    } hover:bg-blue-50 dark:hover:bg-blue-900 transition-colors`}
                  >
                    <ListItemPrefix>{item.icon}</ListItemPrefix>
                    <span className="dark:text-white">{item.label}</span>
                  </ListItem>
                </Link>
              </motion.div>
            ))}
          </List>
        </AccordionBody>
      </motion.div>
    </Accordion>
  );
};

export default CustomAccordion;
